export default {"name":"Ramen","version":"?","sourceHash":"04125e7875db711ddd2f70a5f5ac626d599cc0da\n","basePath":"/","locales":{"en":"English"}};